const Analytics = () => {
  return (
    <iframe
      title="SFS_Bulk_Events_Analytics"
      src="https://app.powerbi.com/reportEmbed?reportId=0cd8640b-0322-43df-9b6b-cb11e038c4ca&autoAuth=true&ctid=ce18dbbe-5ce8-4dac-bbcc-874dba4c0a40"
      frameborder="0"
      allowFullScreen="true"
      style={{ width: "100%", height: "100vh", border: "none" }}
    ></iframe>
    // <iframe
    //     src="https://example.com"
    //     title="Analytics"
    //     style={{ width: '100%', height: '100vh', border: 'none' }}

    // />
  );
};
export default Analytics;
